import React, { useState } from 'react'
import { Box, Grid, Typography, useTheme, TextField, Select, MenuItem, Button } from '@mui/material';
import { useControlPanel } from './ControlPanelProvider';
import LevelRow from './LevelRow';
import * as DeviceAPI from '../axios/device'

const ControlPanel  = () => {

    const theme = useTheme();
    const { levels, addLevel } = useControlPanel();

    const queryParameters = new URLSearchParams(window.location.search)
    const uid = queryParameters.get("uid") || "none"
    const uname = queryParameters.get("uname") || "none"
    const utoken = queryParameters.get("utoken") || "none"
    const [qrCode, setQRCode] = useState();

    const generateQRcode = async () => {
        const { data } = await DeviceAPI.getQRCode({uid, uname, utoken})
        setQRCode(data.data.qr);
    }

    return (
        <>
            <Button onClick={generateQRcode} variant='outlined' sx={{ mb:2 }}>Get QR code</Button>
            <Box display={"flex"}>
                <Box sx ={{ backgroundColor:theme.palette.primary.main}} padding={2}>
                <Box sx={{ display:"flex", height:"100%", alignItems:"center", justifyContent:"center" }}>
                    <Typography sx ={{ color:"white" }} variant='h5'>Lush</Typography>
                </Box>
                </Box>
                <Box flexGrow={1}>

                <Grid container>
                    <Grid item md = {1}></Grid>
                    <Grid item md = {3}>
                    <Typography color="primary">Tip Amount</Typography>
                    </Grid>
                    <Grid item md = {3}>
                    <Typography color="primary">Reaction Time</Typography>
                    </Grid>
                    <Grid item md = {2}>
                    <Typography color="primary">Vibration Power</Typography>
                    </Grid>
                    <Grid item md = {2}>
                    </Grid>
                </Grid>
                {
                    levels.map((level, index)=><LevelRow key = {index} level = {level} index={index} />)
                }
                <Box sx = {{ border:"1px dashed #ff6633", p:2, cursor:"pointer" }} textAlign={"center"} onClick = {addLevel}>
                    <Typography color="primary">
                        + Add Level
                    </Typography>
                </Box>
                </Box>
            </Box>
            {qrCode && <Box component={"img"} src={qrCode} />}
        </>
    )
}

export default ControlPanel;